import apiClient from './api'

const userService = {
  // Get all users
  async getUsers(params = {}) {
    try {
      params['_no_pagination_'] = 1
      params['_with_[departments.roles]'] = ''
      params['_with_[departments.department]'] = ''
      const response = await apiClient.get('/admin/users', { params })
      return response
    } catch (error) {
      console.error('Error fetching users:', error)
      throw error
    }
  },

  // Create new user (form-data for file upload)
  async createUser(formData) {
    try {
      const response = await apiClient.post('/admin/users', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      return response
    } catch (error) {
      console.error('Error creating user:', error)
      throw error
    }
  },

  // Update user (form-data with _method: PUT)
  async updateUser(id, formData) {
    try {
      // Add _method: PUT for Laravel form-data handling
      formData.append('_method', 'PUT')
     
      const response = await apiClient.post(`/admin/users/${id}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      return response
    } catch (error) {
      console.error('Error updating user:', error)
      throw error
    }
  },

  // Delete user
  async deleteUser(id) {
    try {
      const response = await apiClient.delete(`/admin/users/${id}`)
      return response
    } catch (error) {
      console.error('Error deleting user:', error)
      throw error
    }
  },

  // Add user to department
  async addUserToDepartment(userId, departmentData) {
    try {
      const response = await apiClient.post(`/admin/users/${userId}/departments`, departmentData)
      return response
    } catch (error) {
      console.error('Error adding user to department:', error)
      throw error
    }
  },

  // Update user department
  async updateUserDepartment(userId, userDepartmentId, updateData) {
    try {
      const response = await apiClient.put(`/admin/users/${userId}/departments/${userDepartmentId}`, updateData)
      return response
    } catch (error) {
      console.error('Error updating user department:', error)
      throw error
    }
  },

  // Remove user from department
  async removeUserFromDepartment(userId, userDepartmentId) {
    try {
      const response = await apiClient.delete(`/admin/users/${userId}/departments/${userDepartmentId}`)
      return response
    } catch (error) {
      console.error('Error removing user from department:', error)
      throw error
    }
  },

  // Helper method to create FormData from user object
  createFormData(userData) {
    const formData = new FormData()
    
    // Add all fields to FormData
    Object.keys(userData).forEach(key => {
      if (key === 'roles_ids' && Array.isArray(userData[key])) {
        // Handle array fields (roles_ids[])
        userData[key].forEach(roleId => {
          formData.append('roles_ids[]', roleId)
        })
      } else if (key === 'stamp' && userData[key] instanceof File) {
        // Handle file upload
        formData.append('stamp', userData[key])
      } else if (userData[key] !== null && userData[key] !== undefined && userData[key] !== '') {
        // Handle regular fields
        formData.append(key, userData[key])
      }
    })
    
    return formData
  }
}

export default userService 